






































































































  declare let echarts: any;
import { Component, Vue, Watch, Provide, Prop } from "vue-property-decorator";
import { timeFormat } from "@/utils/index";
@Component({
  name: "PerformanceDashboardGroup"
})
export default class PerformanceDashboardGroup extends Vue {
  @Provide() private token: any = "";
  @Provide() private userid: any = "";
  @Provide() private resultPersonalData: any = [];
  @Provide() private resultGroupData: any = [];
  @Provide() private seniorleaderstatsList: any = [];
  @Provide() private updatedTime: any = ""; // 上次更新时间
  @Provide() private chartPerson: any = {};
  @Provide() private timeId: any = null; // 1 组  2 个人
  private created() {
    this.token = localStorage.getItem("token");
    this.userid = this.getUid()?this.getUid():localStorage.getItem("userid"); // 如果在url上匹配到
  }
  private mounted() {
    this.forList(); // 获取列表数据
  }
  private destroyed() {
    let _id = this.timeId;
    clearTimeout(_id);
  }
  private forList() {
    this.getExtenList();
    this.timeId = setTimeout(() => {
      this.forList(); // 获取列表数据
    }, 300000);
  }
  private sortChange(a: any, b: any): number {
    return a-b
  }
  private goDashboard(row: any) {
    let routeData = this.$router.resolve({
      path: "/Performance/dashboard",
      query: {
        uid: row.adminuid
      }
    });
    window.open(routeData.href, '_blank');
  }
  private getUid() {
    if(this.$route.query&&this.$route.query.uid){
      return this.$route.query.uid;
    }
    return ""
  }
  private async getExtenList() {
    let _arg = {
      trackId: "",
      clientId: "",
      token: this.token,
      userid: Number(this.userid)
    }
    const { getUrgeDashboardApi }: any = await import("@/request/dashboard");
    let res = await getUrgeDashboardApi(_arg);
    if(res){
      this.groupList(res);
    }
  }

  private groupList(data: any){
    if(data && data.leaderstatsList) {
      let _result_group: any = typeof data.leaderstatsList == 'object'?data.leaderstatsList:JSON.parse(data.leaderstatsList);
      this.resultGroupData =_result_group;
    }
    if(data && data.staffstatsList) {
      let _result_person: any = typeof data.staffstatsList == 'object'?data.staffstatsList:JSON.parse(data.staffstatsList);
      this.resultPersonalData =_result_person;
    }
    if(data && data.seniorleaderstatsList) {
      let _result_seniorleader: any = typeof data.seniorleaderstatsList == 'object'?data.seniorleaderstatsList:JSON.parse(data.seniorleaderstatsList);
      this.seniorleaderstatsList =_result_seniorleader;
    }
    this.chartPerson = data.pies;
    this.updatedTime = timeFormat(this.chartPerson.updatetime);
  }
}
